// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-text-field__slot input::-webkit-calendar-picker-indicator {\n  display: none;\n}\n.v-text-field__slot input[type=\"date\"] {\n  cursor: text;\n}\n.v-text-field__slot input[type=\"date\"]::-webkit-input-placeholder {\n  visibility: hidden;\n}\nspan.registeredTrademark {\n  position: relative;\n  top: -.3rem;\n  font-size: .5rem;\n  left: -0.05rem;\n}\nfooter {\n  font-size: small;\n}\n", ""]);
// Exports
module.exports = exports;
